// 💡 Auto import all routes from module/*/router/index.ts
const modules = import.meta.glob('@/modules/*/locales/vi.ts', { eager: true })
// console.log(modules)

let phrases = {}
Object.values(modules).forEach((mod: any) => {
  if (!Array.isArray(mod.default)) {
    phrases = {
      ...phrases,
      ...mod.default,
    }
  }
  // mod.default should be a route array or a single route
  // return Array.isArray(mod.default) ? mod.default : [mod.default]
})

export default {
  auth: {
    login: {
      title: 'Đăng nhập',
      credentials: {
        email: 'Email',
        password: 'Mật khẩu',
      },
    },
  },
  dashboard: {
    title: 'Bảng điều khiển',
    welcome: 'Chào mừng bạn đến với bảng điều khiển của chúng tôi',
    settings: {
      title: 'Cài đặt',
      language: 'Ngôn ngữ',
      theme: 'Chủ đề',
    },
  },
  filter: {
    button: {
      apply: 'Lọc',
    },
  },
  ...phrases,
}
